<template>
  <div
    class="rounded-xl p-6 text-white flex items-center justify-between gap-5 bg-gradient-to-r from-primary-dark to-primary"
  >
    <div class="flex items-center gap-4 min-w-0">
      <div class="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center shrink-0">
        <Icon name="mdi-card-account-details-star-outline" :size="30" color="#fff" />
      </div>
      <div class="min-w-0">
        <div class="text-xl font-bold leading-tight truncate">
          {{ name }}
        </div>
        <div class="text-sm opacity-80 mt-0.5 truncate">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div class="flex items-center gap-3 shrink-0">
      <div
        v-if="ruleLabel"
        class="hidden md:flex items-center gap-2.5 bg-white/15 rounded-xl px-4 py-3"
      >
        <Icon name="mdi-gift-outline" :size="22" color="#fff" />
        <div>
          <div class="text-[11px] opacity-80">
            Règle de récompense
          </div>
          <div class="text-sm font-semibold">
            {{ ruleLabel }}
          </div>
        </div>
      </div>

      <button
        type="button"
        class="flex items-center gap-2 bg-white text-primary rounded-xl px-4 py-3 text-sm font-semibold transition-opacity"
        :class="exportable && !exporting ? 'hover:opacity-90' : 'opacity-60 cursor-not-allowed'"
        :disabled="!exportable || exporting"
        :title="exportable || exporting ? undefined : 'Bientôt disponible'"
        @click="onExport"
      >
        <Icon :name="exporting ? 'mdi-loading' : 'mdi-download-outline'" :size="19" color="#3513e2" :class="exporting ? 'animate-spin' : ''" />
        {{ exporting ? 'Export en cours…' : 'Exporter' }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import Icon from "@/core/components/icon/Icon.vue";

const props = withDefaults(defineProps<{
    /** The loyalty card / program name. */
    name: string;
    /** The organization (laboratory) name shown as sub-title. */
    organizationName?: string | null;
    /** The reward-rule label, e.g. "10 produits achetés = 1 offert". */
    ruleLabel?: string | null;
    /** Whether the export action is available. */
    exportable?: boolean;
    /** Whether an export is currently running. */
    exporting?: boolean;
}>(), {
    organizationName: null,
    ruleLabel: null,
    exportable: false,
    exporting: false
});

const emit = defineEmits<{(e: "export"): void}>();

const subtitle = computed(() => (
    props.organizationName
        ? `Programme de fidélité · ${props.organizationName}`
        : "Programme de fidélité"
));

const onExport = () => {
    if (props.exportable && !props.exporting) {
        emit("export");
    }
};
</script>
